/** server handled errors */
export enum HandledErrorTypes {
    GPTContentFilterError = 'GPT Content Filter Error',
    TooManyRequests = 'Too Many Requests',
}